
import ScreenUtils from '~/mixins/Utils/ScreenUtils'

export default {
    mixins: [ScreenUtils],
    props: {
        files: Array,
        label: String,
        delay: Number,
        noData: Boolean,
        rows: {
            type: Number,
            default: () => 1
        },
        titleIsCenter: Boolean
    },
    data() {
        return {
            flickity: null
        }
    },
    watch: {
        files(val) {
            if (val !== null && val.length > 0) {
                this.initFlickity()
                this.flickity.remove(this.flickity.getCellElements())
                this.insertCells(this.files)
                this.flickity.select(0)
            }
        },
        noData(val) {
            if (val) {
                this.flickity?.destroy()
                this.flickity = null
            }
        },
        screenType() {
            if (!this.flickity){
                return
            }
            this.flickity.remove(this.flickity.getCellElements())
            this.insertCells(this.files)
            this.flickity.resize()
            this.flickity.select(0)
        }
    },
    mounted() {
        if (this.files !== null && this.files.length > 0) {
            this.initFlickity()
            this.insertCells(this.files)
            this.flickity.select(0)
        }
    },
    methods: {
        initFlickity() {
            if (this.flickity) {
                return
            }
            const Flickity = require('flickity')
            this.flickity = new Flickity(this.$refs.flickity, {
                rightToLeft: true,
                cellAlign: 'right',
                prevNextButtons: true,
                groupCells: true,
                pauseAutoPlayOnHover: true,
                pageDots: false
            })
            this.flickity.on('staticClick', (e, pointer, cellElement) => {
                if (!cellElement) {
                    return
                }
                const elHash = e.target.dataset.hash ?? e.target.parentElement.dataset.hash ?? e.target.parentElement.parentElement.dataset.hash
                if (!elHash) {
                    return
                }
                this.$router.push(`/File/${elHash}`)
            })
        },
        insertCells(elms) {
            const perChunk = this.rows * this.getColumnsNumber()
            const result = elms.reduce((resultArray, item, index) => {
                const chunkIndex = Math.floor(index / perChunk)

                if (!resultArray[chunkIndex]) {
                    resultArray[chunkIndex] = [] // start a new chunk
                }

                resultArray[chunkIndex].push(item)

                return resultArray
            }, [])
            const maxPageElements = result.reduce((resultArray, item, index) => {
                if (item.length > resultArray.length){
                    return item
                }
                return resultArray
            }, [])
            const maxRows = maxPageElements.reduce((resultArray, item, index) => {
                const chunkIndex = Math.floor(index / this.getColumnsNumber())

                if (!resultArray[chunkIndex]) {
                    resultArray[chunkIndex] = [] // start a new chunk
                }

                resultArray[chunkIndex].push(item)

                return resultArray
            }, []).length
            const cells = []
            result.forEach((el) => {
                const cell = this.htmlToElement(`<div class="w-full py-4 pl-4 grid ${this.getGridClass(maxRows)} ${this.getGridClass(this.getColumnsNumber(), false)} gap-6">
                      ${el.map(e => this.generateArticleHtml(e)).join('')}
                    </div>`)
                cells.push(cell)
            })
            this.flickity.append(cells)
        },
        generateArticleHtml(el) {
            return `<article data-hash="${el.hash}"
                        class="border border-slate-100 relative shadow-sm hover:shadow-md rounded flex flex-col gap-2 justify-center p-6 cursor-pointer">
                              <span class="absolute left-0 top-0 -translate-y-1/2 ml-2 text-xs rounded bg-sky-50 text-sky-700 px-2 py-0.5">
                            ${el.type}
                          </span>
                          <h3 title="${el.name}" class="text-sm text-slate-700 line-clamp-1">
                            ${el.name}
                          </h3>
                          ${!el.desc || !el.desc.length ? '' : `<p title="${el.desc}" class="text-sm text-slate-500 line-clamp-3">${el.desc}</p>`}
                      </article>`
        },
        getGridClass(rowNum, isRow = true) {
            switch (rowNum) {
                case 1:
                    return isRow ? 'grid-rows-1' : 'grid-cols-1'
                case 2:
                    return isRow ? 'grid-rows-2' : 'grid-cols-2'
                case 3:
                    return isRow ? 'grid-rows-3' : 'grid-cols-3'
                case 4:
                    return isRow ? 'grid-rows-4' : 'grid-cols-4'
                case 5:
                    return isRow ? 'grid-rows-5' : 'grid-cols-5'
            }
        },
        htmlToElement(html) {
            const template = document.createElement('template')
            html = html.trim() // Never return a text node of whitespace as the result
            template.innerHTML = html
            return template.content.firstChild
        },
        getColumnsNumber() {
            if (this.isPhone()) {
                return 1
            }
            if (this.isTablet()) {
                return 2
            }

            return 3
        }
    }
}
